import React from 'react';
import { Redirect } from 'react-router-dom';

import { decodeJwt } from 'shared/helpers';

import {
  HomeExternal,
  // HomeInternal
} from './_home';


const Home = ({ sessionState, ...props }) => {
  const jwt = sessionState.get('jwt');
  const { sub: handle } = decodeJwt(jwt);

  // NOTE: For now, user entity page is the only
  // thing available so redirect there..
  return (handle
    ? <Redirect to={`/@${handle}`} />
    : <HomeExternal />
  );
};


export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js